import { Col } from 'antd';
import { InterventionPathContextType } from 'components/intervention/context/InterventionPathContext';
import React from 'react';
import {
	InterventionCreatedAt,
	InterventionNumber,
	InterventionOwner,
	InterventionPath,
	InterventionRealizationBudget,
	InterventionRealizationDate,
	InterventionStatus,
} from '../InterventionFields';

const SupervisionSanitaryInfoFieldGroup: React.FC<InterventionPathContextType> = (
	props
) => {
	return (
		<>
			<Col span={12}>{InterventionPath(props)}</Col>
			<Col span={12}>{InterventionStatus(props)}</Col>
			<Col span={12}>{InterventionOwner(props)}</Col>
			<Col span={12}>{InterventionRealizationDate(props)}</Col>
			<Col span={12}>{InterventionNumber(props)}</Col>
			<Col span={12}>{InterventionRealizationBudget(props)}</Col>
			<Col span={12}>{InterventionCreatedAt(props)}</Col>
		</>
	);
};

export default SupervisionSanitaryInfoFieldGroup;
